(() => {
  if (!window.Zeta || !window.Zeta.config.enabled || !window.Zeta.config.suggestEnabled) {
    return;
  }

  const predictiveSearchUrl = window.theme?.routes?.predictive_search_url;
  if (typeof predictiveSearchUrl !== 'string') {
    return;
  }

  const SEARCH_HISTORY_KEY = 'zeta_search_history';
  const SEARCH_HISTORY_MAX = 10;
  const SUGGEST_PRODUCT_LIMIT = 6;
  const originalFetch = window.fetch;

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (char) => {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function keywordLink(keyword, className) {
    const href = escapeHtml(window.Zeta.buildResultsUrl(keyword));
    return `<a class="${className}" href="${href}">${escapeHtml(keyword)}</a>`;
  }

  function productCard(item) {
    const href = escapeHtml(item.url);
    const img = escapeHtml(item.imageUrl);
    const priceClass = item.onSale ? 'zeta-suggest__price zeta-suggest__price--sale' : 'zeta-suggest__price';
    const media = img ? `<img src="${img}" alt="" loading="lazy" width="200" height="266">` : '';
    return `<a class="zeta-suggest__product" href="${href}">
      <span class="zeta-suggest__product-media">${media}</span>
      <span class="zeta-suggest__product-name">${escapeHtml(item.title)}</span>
      <span class="${priceClass}">${escapeHtml(window.Zeta.formatMoney(item.price))}</span>
    </a>`;
  }

  async function fetchSuggestItems(term) {
    try {
      return await window.Zeta.fetchItems({ q: term, l: SUGGEST_PRODUCT_LIMIT, stock: 0 });
    } catch (error) {
      console.error('[ZETA] suggest items', error);
      return { items: [] };
    }
  }

  async function buildSuggestHtml(term) {
    const [suggest, itemsResult] = await Promise.all([
      // LB の suggest API が一時的に 500 を返しても、商品検索候補は表示する。
      window.Zeta.fetchSuggest(term).catch(() => ({ suggestions: [], popularWords: [] })),
      fetchSuggestItems(term),
    ]);

    const keywordSections = [];
    if (suggest.suggestions.length > 0) {
      const links = suggest.suggestions.map((word) => `<li>${keywordLink(word, 'zeta-suggest__link')}</li>`).join('');
      keywordSections.push(
        `<p class="zeta-suggest__title">もしかして</p><ul class="zeta-suggest__list">${links}</ul>`,
      );
    }
    if (suggest.popularWords.length > 0) {
      const chips = suggest.popularWords.map((word) => keywordLink(word, 'zeta-suggest__keyword')).join('');
      keywordSections.push(
        `<p class="zeta-suggest__title">人気のキーワード</p><div class="zeta-suggest__chips">${chips}</div>`,
      );
    }

    const products = itemsResult.items || [];
    let productsHtml = '';
    if (products.length > 0) {
      const cards = products.map(productCard).join('');
      productsHtml = `<p class="zeta-suggest__title">${escapeHtml(term)}</p>
        <div class="zeta-suggest__products">${cards}</div>`;
    }

    return `<div id="shopify-section-predictive-search"><div class="zeta-suggest">${keywordSections.join('')}${productsHtml}</div></div>`;
  }

  function isPredictiveSearchRequest(input, init) {
    const requestUrl = input instanceof Request ? input.url : String(input);
    const requestMethod = (init?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    return requestMethod === 'GET' && requestUrl.startsWith(predictiveSearchUrl);
  }

  window.fetch = async function zetaFetch(input, init) {
    if (!isPredictiveSearchRequest(input, init)) {
      return originalFetch(input, init);
    }

    try {
      const requestUrl = input instanceof Request ? input.url : String(input);
      const term = new URL(requestUrl, window.location.origin).searchParams.get('q') || '';
      const html = await buildSuggestHtml(term);
      return new Response(html, {
        status: 200,
        headers: { 'Content-Type': 'text/html' },
      });
    } catch (error) {
      console.error('[ZETA] suggest', error);
      return originalFetch(input, init);
    }
  };

  function readSearchHistory() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(SEARCH_HISTORY_KEY) || '[]');
      return Array.isArray(stored) ? stored.slice(0, SEARCH_HISTORY_MAX) : [];
    } catch (error) {
      console.error('[ZETA] search history', error);
      return [];
    }
  }

  function buildKeywordLink(keyword, className) {
    const link = document.createElement('a');
    link.className = className;
    link.href = window.Zeta.buildResultsUrl(keyword);
    link.textContent = keyword;
    return link;
  }

  function initializeInitialPanel() {
    const quickSearch = document.querySelector('[data-quick-search]');
    const form = quickSearch?.querySelector('form[data-quick-search-form]');
    const resultsWrapper = form?.querySelector('.quick-search__results-wrapper');
    const input = form?.querySelector('[data-input]');
    if (!form || !resultsWrapper || !input || form.querySelector('[data-zeta-initial]')) {
      return;
    }

    const panel = document.createElement('div');
    panel.className = 'zeta-suggest zeta-suggest__initial';
    panel.dataset.zetaInitial = '';

    const history = readSearchHistory();
    if (history.length > 0) {
      const historySection = document.createElement('div');
      historySection.className = 'zeta-suggest__initial-section';
      const historyTitle = document.createElement('p');
      historyTitle.className = 'zeta-suggest__title';
      historyTitle.textContent = '検索履歴';
      const historyList = document.createElement('ul');
      historyList.className = 'zeta-suggest__list';
      history.forEach((keyword) => {
        const listItem = document.createElement('li');
        listItem.appendChild(buildKeywordLink(keyword, 'zeta-suggest__link'));
        historyList.appendChild(listItem);
      });
      historySection.appendChild(historyTitle);
      historySection.appendChild(historyList);
      panel.appendChild(historySection);
    }

    const popularSection = document.createElement('div');
    popularSection.className = 'zeta-suggest__initial-section';
    popularSection.hidden = true;
    panel.appendChild(popularSection);
    form.insertBefore(panel, resultsWrapper);

    let popularWordsRequested = false;
    input.addEventListener('focus', async () => {
      if (popularWordsRequested) {
        return;
      }
      popularWordsRequested = true;
      try {
        const suggest = await window.Zeta.fetchSuggest('');
        if (suggest.popularWords.length === 0) {
          return;
        }
        const title = document.createElement('p');
        title.className = 'zeta-suggest__title';
        title.textContent = '人気のキーワード';
        const chips = document.createElement('div');
        chips.className = 'zeta-suggest__chips';
        suggest.popularWords.forEach((keyword) => {
          chips.appendChild(buildKeywordLink(keyword, 'zeta-suggest__keyword'));
        });
        popularSection.appendChild(title);
        popularSection.appendChild(chips);
        popularSection.hidden = false;
      } catch (error) {
        // 人気キーワードは補助表示のため、API障害時は非表示のまま継続する。
      }
    });

    const togglePanel = () => {
      panel.hidden = input.value.trim().length > 0;
    };
    input.addEventListener('input', togglePanel);
    togglePanel();
  }

  initializeInitialPanel();
})();
